export default class AbstractPage {
  constructor({ el }) {
    if (!el) {
      console.error('no element found for homepage');
      return;
    }

    this.el = el;
    this.$el = $(el);

    this.declareProperties();

    this.init();
  }

  init() {
  }

  declareProperties() {
  }
}
